import { LANGUAGES } from 'utils/constants/general/languages';

import { LanguageLinksContainer } from './LanguageLinks.styled';
import { LanguageLinksItem } from './LanguageLinksItem';

type Props = {
  urlByLocale: Record<UserLocale, string | undefined> | undefined;
};

export function LanguageLinks({ urlByLocale }: Props) {
  return (
    <LanguageLinksContainer>
      {(Object.keys(LANGUAGES) as UserLocale[]).map((locale) => (
        <LanguageLinksItem
          key={locale}
          locale={locale}
          localeUrl={urlByLocale?.[locale]}
        />
      ))}
    </LanguageLinksContainer>
  );
}
